module.exports = __webpack_public_path__ + "static/krzysztof-da54dd7be77336360cd7cc71eaacc86b.jpg";